import { render, staticRenderFns } from "./v-gridform-builder-tour.vue?vue&type=template&id=f5063680&"
import script from "./v-gridform-builder-tour.vue?vue&type=script&lang=js&"
export * from "./v-gridform-builder-tour.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports